// @flow
import { Record } from "immutable";

export type EventRegistrantRecordI = {
  id: string,
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  status: string,
  checkedIn: boolean,
  isCheckInPending: boolean,
  set: (key: string, value: mixed) => EventRegistrantRecordI,
};

const RegistrantRecord = Record({
  id: "",
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  status: "",
  checkedIn: false,
  isCheckInPending: false,
});

export default RegistrantRecord;
